import {Button, Grid, Typography} from '@material-ui/core';
import {useSelfInfo} from 'hooks/users';
import React from 'react';
import jMoment from 'moment-jalaali';
import Badge from '../newComponents/Badge';
import SelectMessageIcon from '../../../assets/icons/messages.svg';
import {useHistory} from 'react-router-dom/cjs/react-router-dom';
import SnackbarUtil from 'utils/snackbar';

const AdvisingSet = ({
  upcoming,
  link,
  doing,
  name,
  nickname,
  duration,
  type,
  start,
  avatar,
  thumbnail,
  title,
}) => {
  const {selfInfo} = useSelfInfo();

  const userType = selfInfo?.userType;

  const session =
    userType === 'ADVISER'
      ? selfInfo?.comingUpIncomingAdviseSession ||
        selfInfo?.comingUpOutgoingAdviseSession
      : selfInfo?.comingUpOutgoingAdviseSession;
  const from =
    userType === 'ADVISER' && selfInfo?.comingUpIncomingAdviseSession
      ? session?.fromUser
      : userType === 'USER'
      ? session?.adviser
      : userType === 'ADVISER' && selfInfo?.comingUpOutgoingAdviseSession
      ? session?.adviser
      : '';

  const history = useHistory();

  return (
    <>
      {doing && (
        <Grid
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            marginBottom: 20,
            width: '100%',
            padding: 10,
          }}
        >
          <Typography
            style={{
              fontWeight: 600,
              fontSize: 16,
              fontFamily: 'IRANSansX',
              color: '#1D2129',
            }}
          >
            {'جلسه در حال برگزاری...'}
          </Typography>
          <Grid
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-around',
              alignItems: 'center',
              borderRadius: '24px',
              border: '1px solid #F2F3F5',
              width: '100%',
              height: '160px',
            }}
          >
            {userType === 'USER' ? (
              <Grid container style={{display: 'flex', flexDirection: 'row'}}>
                <Grid
                  item
                  xs={3}
                  md={2}
                  justifyContent="center"
                  style={{display: 'flex'}}
                >
                  <img
                    src={thumbnail || avatar}
                    alt=""
                    style={{
                      width: '56px',
                      height: '56px',
                      borderRadius: '50%',
                      backgroundColor: '#EDF7FF',
                      marginTop: 10,
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={4}
                  md={3}
                  justifyContent="center"
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <Grid item xs={12}>
                    <Typography
                      style={{
                        fontSize: 14,
                        fontWeight: 500,
                        fontFamily: 'IRANSansX',
                        marginTop: 15,
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {(name?.length > 17 ? name.slice(0, 17) + '...' : name) ||
                        'ناشناس'}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      style={{
                        fontSize: 12,
                        color: '#86909C',
                        fontFamily: 'IRANSansX',
                        fontWeight: 400,
                        marginTop: 10,
                      }}
                    >
                      {title}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  item
                  justifyContent="center"
                  xs={4}
                  md={7}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <Grid>
                    <Grid
                      item
                      xs={12}
                      justifyContent="flex-end"
                      style={{display: 'flex', marginTop: 7, marginLeft: 20}}
                    >
                      <Badge item={'doing'} />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      justifyContent="flex-end"
                      style={{display: 'flex'}}
                    >
                      <Typography
                        style={{
                          fontSize: 12,
                          color: '#86909C',
                          fontFamily: 'IRANSansX',
                          marginTop: 15,
                          marginLeft: 20,
                        }}
                      >
                        {jMoment.unix(start).format('jYYYY/jMM/jDD - HH:mm')}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              //Advisers-------------------------
              <Grid
                container
                justifyContent="center"
                style={{display: 'flex', flexDirection: 'row'}}
              >
                <Grid
                  item
                  xs={7}
                  justifyContent="center"
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginRight: 5,
                  }}
                >
                  <Grid item xs={12}>
                    <Typography
                      style={{
                        fontFamily: 'IRANSansX',
                        fontWeight: 400,
                        fontSize: 12,
                        color: '#86909C',
                        marginRight: 5,
                        marginTop: 7,
                      }}
                    >
                      درخواست ویزیت مراجع:
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      style={{
                        fontSize: 16,
                        fontWeight: 500,
                        fontFamily: 'IRANSansX',
                        marginRight: 5,
                        marginTop: 5,
                      }}
                    >
                      {(nickname?.length > 17
                        ? nickname.slice(0, 17) + '...'
                        : nickname) || 'ناشناس'}
                    </Typography>
                  </Grid>
                </Grid>

                <Grid
                  item
                  justifyContent="center"
                  xs={4}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <Grid>
                    <Grid
                      item
                      xs={12}
                      justifyContent="flex-end"
                      style={{display: 'flex', marginTop: 5}}
                    >
                      <Badge item={'doing'} />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      justifyContent="flex-end"
                      style={{display: 'flex'}}
                    >
                      <Typography
                        style={{
                          fontSize: 12,
                          color: '#86909C',
                          fontFamily: 'IRANSansX',
                          marginTop: 15,
                          marginLeft: 10,
                        }}
                      >
                        {jMoment.unix(start).format('jYYYY/jMM/jDD - HH:mm')}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            )}

            <Grid
              item
              container
              style={{display: 'flex', flexDirection: 'row'}}
            >
              <Grid
                item
                xs={7}
                md={10}
                justifyContent="center"
                style={{display: 'flex', marginBottom: 10}}
              >
                <Button
                  variant="outlined"
                  color="primary"
                  style={{
                    backgroundColor: '#F7F8FA',
                    border: 'none',
                    borderRadius: '12px',
                    color: '#4E5969',
                    fontSize: '12px',
                    fontWeight: 500,
                    height: '40px',
                    width: '90%',
                    fontFamily: 'IRANSansX',
                    whiteSpace: 'nowrap',
                  }}
                >
                  <img
                    style={{width: '20px', height: '20px', marginLeft: 4}}
                    alt="گفتگو ها"
                    src={SelectMessageIcon}
                  />
                  {`مشاوره ${
                    type === 'CHAT'
                      ? 'متنی'
                      : type === 'VOIP_CALL'
                      ? 'تلفنی'
                      : type === 'VIDEO_CALL'
                      ? 'تصویری'
                      : type === 'VOICE_CALL'
                      ? 'صوتی'
                      : 'نامشخص'
                  } - ${duration} دقیقه`}
                </Button>
              </Grid>
              <Grid
                item
                xs={5}
                md={2}
                justifyContent="flex-start"
                style={{display: 'flex'}}
              >
                <Button
                  onClick={() => {
                    history.push(`/app/advise-sessions/${link}`);
                  }}
                  variant="outlined"
                  color="primary"
                  style={{
                    border: '1px solid #30ACFF',
                    borderRadius: '12px',
                    color: '#30ACFF',
                    fontSize: '14px',
                    fontWeight: 500,
                    height: '40px',
                    width: '90%',
                    fontFamily: 'IRANSansX',
                  }}
                >
                  ورود به جلسه
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
      {upcoming && session && (
        <Grid
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            marginBottom: 20,
            width: '100%',
            padding: 10,
          }}
        >
          <Typography
            style={{
              fontWeight: 600,
              fontSize: 16,
              fontFamily: 'IRANSansX',
              color: '#1D2129',
            }}
          >
            {'جلسه زمان بندی شده'}
          </Typography>
          <Grid
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-around',
              alignItems: 'center',
              borderRadius: '24px',
              border: '1px solid #F2F3F5',
              width: '100%',
              height: '160px',
            }}
          >
            {userType === 'USER' ? (
              <Grid container style={{display: 'flex', flexDirection: 'row'}}>
                <Grid
                  item
                  xs={3}
                  justifyContent="center"
                  style={{display: 'flex'}}
                >
                  <img
                    src={from.avatar?.thumbnail || from.avatar?.avatar}
                    alt=""
                    style={{
                      width: '56px',
                      height: '56px',
                      borderRadius: '50%',
                      backgroundColor: '#EDF7FF',
                      marginTop: 10,
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={4}
                  justifyContent="center"
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <Grid item xs={12}>
                    <Typography
                      style={{
                        fontSize: 14,
                        fontWeight: 500,
                        fontFamily: 'IRANSansX',
                        marginTop: 15,
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {selfInfo?.comingUpIncomingAdviseSession
                        ? from?.nickname || 'ناشناس'
                        : from.firstName + ' ' + from.lastName}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      style={{
                        fontSize: 12,
                        color: '#86909C',
                        fontFamily: 'IRANSansX',
                        fontWeight: 400,
                        marginTop: 10,
                      }}
                    >
                      {from?.skills?.[0]?.title}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  item
                  justifyContent="center"
                  xs={4}
                  style={{
                    marginLeft: 5,
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <Grid>
                    <Grid
                      item
                      xs={12}
                      justifyContent="flex-end"
                      style={{display: 'flex', marginTop: 5}}
                    >
                      <Badge item={'reserved'} />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      justifyContent="flex-end"
                      style={{display: 'flex'}}
                    >
                      <Typography
                        style={{
                          fontSize: 12,
                          color: '#86909C',
                          fontFamily: 'IRANSansX',
                          marginTop: 15,
                          marginLeft: 10,
                        }}
                      >
                        {jMoment
                          .unix(session?.startAt)
                          .format('jYYYY/jMM/jDD - HH:mm')}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              //Advisers-------------------------
              <Grid
                container
                justifyContent="center"
                style={{display: 'flex', flexDirection: 'row'}}
              >
                <Grid
                  item
                  xs={7}
                  justifyContent="center"
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <Grid item xs={12}>
                    <Typography
                      style={{
                        fontFamily: 'IRANSansX',
                        fontWeight: 400,
                        fontSize: 12,
                        color: '#86909C',
                        marginRight: 5,
                        marginTop: 7,
                      }}
                    >
                      درخواست ویزیت مراجع:
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      style={{
                        fontSize: 16,
                        fontWeight: 500,
                        fontFamily: 'IRANSansX',
                        marginRight: 5,
                        marginTop: 5,
                      }}
                    >
                      {selfInfo?.comingUpIncomingAdviseSession
                        ? from?.nickname || 'ناشناس'
                        : from.firstName + ' ' + from.lastName}
                    </Typography>
                  </Grid>
                </Grid>

                <Grid
                  item
                  justifyContent="center"
                  xs={4}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <Grid>
                    <Grid
                      item
                      xs={12}
                      justifyContent="flex-end"
                      style={{display: 'flex', marginTop: 5}}
                    >
                      <Badge item={'reserved'} />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      justifyContent="flex-end"
                      style={{display: 'flex'}}
                    >
                      <Typography
                        style={{
                          fontSize: 12,
                          color: '#86909C',
                          fontFamily: 'IRANSansX',
                          marginTop: 15,
                          marginLeft: 10,
                        }}
                      >
                        {jMoment
                          .unix(session?.startAt)
                          .format('jYYYY/jMM/jDD - HH:mm')}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            )}
            <Grid
              item
              container
              style={{display: 'flex', flexDirection: 'row'}}
            >
              <Grid
                item
                xs={7}
                md={10}
                justifyContent="center"
                style={{display: 'flex', marginBottom: 10}}
              >
                <Button
                  variant="outlined"
                  color="primary"
                  style={{
                    backgroundColor: '#F7F8FA',
                    border: 'none',
                    borderRadius: '12px',
                    color: '#4E5969',
                    fontSize: '12px',
                    fontWeight: 500,
                    height: '40px',
                    width: '90%',
                    fontFamily: 'IRANSansX',
                    whiteSpace: 'nowrap',
                    marginRight: 4,
                  }}
                >
                  <img
                    style={{width: '20px', height: '20px', marginLeft: 4}}
                    alt="گفتگو ها"
                    src={SelectMessageIcon}
                  />
                  {`مشاوره ${
                    session?.type === 'CHAT'
                      ? 'متنی'
                      : session?.type === 'VOIP_CALL'
                      ? 'تلفنی'
                      : session?.type === 'VIDEO_CALL'
                      ? 'تصویری'
                      : session?.type === 'VOICE_CALL'
                      ? 'صوتی'
                      : 'نامشخص'
                  } - ${session?.duration} دقیقه`}
                </Button>
              </Grid>
              <Grid
                item
                xs={5}
                md={2}
                justifyContent="flex-start"
                style={{display: 'flex'}}
              >
                <Button
                  onClick={() => {
                    SnackbarUtil.warning(
                      'شروع این جلسه مشاوره برای تاریخ و ساعت دیگری زمانبندی شده است!',
                    );
                  }}
                  variant="outlined"
                  color="primary"
                  style={{
                    border: '1px solid #C9CDD4',
                    borderRadius: '12px',
                    color: '#86909C',
                    fontSize: '14px',
                    fontWeight: 500,
                    height: '40px',
                    width: '90%',
                    marginLeft: 4,
                    fontFamily: 'IRANSansX',
                  }}
                >
                  در انتظار شروع
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default AdvisingSet;
